export default __webpack_public_path__ + "static/logo_500-d776e650c57cc9bc4cf096bb93310f92.png";